import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import DataTable from '../../../../Common/DataTable';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import { RootState } from '../../../../redux/rootState';
import {
  deleteContactStart, getContactByIdStart, getContactsStart, removeSelectedContact,
} from '../../redux/addCustomerSlice';
import { ContactMasterColumns } from '../../utils/data';
import { formatMasterTableData } from '../../utils/helper';
import { ContactsData, GetContactByIdPayload } from '../../utils/types';
import AddContactModal from './Components/AddContactModal';
import ComponentPageHeader from '../../../../Common/PageHeader/ComponentPageHeader';
import { setLoader } from '../../../../redux/loaderSlice';
import { defaultPageSize } from '../../../../utils/Constant';

export default function CustomerContactsMaster() {
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const dispatch = useDispatch();
  const {
    contactList, contactTotalEntries, isLoading,
  } = useSelector((state:RootState) => state.addCustomerReducer);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [mode, setMode] = useState('');

  const handleData = async () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };

    dispatch(getContactsStart(payload));
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleClose = () => {
    setShow(false);
    dispatch(removeSelectedContact());
  };

  //   const handleButtonClick = () => {
  //     setMode('Add Contact');
  //     setShow(true);
  //   };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const handleEdit = (contactId:string) => {
    setMode('Edit Contact');
    dispatch(getContactByIdStart(contactId));
    setShow(true);
  };
  const handleDelete = (id:string) => {
    setDeleteModal(true);
    setSelectedId(id);
  };

  const handleDeleteModal = () => {
    const da = contactList?.find((item) => String(item?.ContactId) === selectedId);
    const payload:GetContactByIdPayload = {
      customerId: da?.CustomerId || '',
      contactId: selectedId,
      page,
      searchQuery,
      rowsPerPage,
      sortCol,
      sortDir,
      isMaster: true,
    };
    dispatch(deleteContactStart(payload));
    setDeleteModal(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="CONTACTS" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <div id="contact-tab-content">
          <DataTable<ContactsData>
            // handleButtonClick={handleButtonClick}
            data={contactList ? formatMasterTableData(contactList) : []}
            columns={ContactMasterColumns}
            totalRecords={contactTotalEntries}
            // buttonText="Add Contact"
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            handleData={handleData}
            checkBoxColumns={['ectReport', 'oilReport']}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleDataFromComponent
          />
          <AddContactModal
            show={show && !isLoading}
            handleClose={handleClose}
            mode={mode}
            page={page}
            rowsPerPage={rowsPerPage}
            searchQuery={searchQuery}
            sortCol={sortCol}
            sortDir={sortDir}
            isMaster
          />
          <ComponentDeleteModal
            show={showDeleteModal}
            setOpenFrom={() => setDeleteModal(false)}
            handleDelete={handleDeleteModal}
          />
        </div>
      </Grid>
    </Grid>

  );
}
